import {sizePx, sizeRem} from '@/theme/helpers/size';
import colors from '@/theme/constants/colors';
import typography from '@/theme/typography';
import styled from 'styled-components';
import focus from '@/theme/focus';
import IconButton from '../Buttons/Icon/IconButton';

export const StyledFileUploader = styled.div`
  background: ${colors.grey};
  border-radius: ${sizePx(2)};
  ${typography.Body2}
  color: ${colors.darkBlue100};
`;

export const StyledFileUploaderTopRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.grey75};
  padding: ${sizePx(8)};
`;

export const StyledFileUploaderContent = styled.div`
  padding: ${sizePx(2)} ${sizePx(8)};
`;

export const StyledFileUploaderLabel = styled.label``;

export const StyledFileUploaderButton = styled.button`
  border: none;
  border-radius: 4px;
  background: ${colors.grey50};
  color: ${colors.darkBlue100};
  padding: ${sizePx(3)} ${sizePx(5)};
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${colors.grey75};
    }
  }

  ${focus.brand()}
`;

export const StyledFileUploaderDefaultMsg = styled.p`
  ${typography.Body3}
  color: ${colors.darkBlue75};
  text-align: center;
  margin: ${sizePx(5)} 0;
`;

export const StyledFileUploaderList = styled.ul`
  max-height: ${sizePx(100)};
  overflow-y: scroll;

  li {
    display: grid;
    grid-template-columns: minmax(0, 1fr) ${sizePx(30)} ${sizePx(15)};
    gap: ${sizePx(4)};
    align-items: center;
    min-height: ${sizePx(20)};
    border-bottom: 1px solid ${colors.grey75};

    &:last-of-type {
      border: none;
    }

    span:first-of-type {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span:nth-of-type(2) {
      color: ${colors.darkBlue50};
      text-align: right;
      white-space: nowrap;
    }
  }
`;

export const StyledFileUploaderErrorList = styled.ul`
  ${typography.Body3}
  color: ${colors.red200};
  list-style: none;
  margin: 0 0 ${sizePx(6)};
  padding: 0;
`;

export const StyledRemoveButton = styled(IconButton)`
  width: ${sizePx(15)};
  height: ${sizePx(15)};
  font-size: ${sizeRem(6)};
  color: ${colors.darkBlue50};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${colors.darkBlue75};
    }
  }
`;
